@if (formGroup) {
  <form [formGroup]="formGroup" [class.mb-3]="has_mb3" [class.my-3]="has_my3">
    <dk-label [label]="label" [isRequired]="required" [disabled]="disabled || control?.disabled" />
    <p-select
      #drop
      [formControlName]="controlName"
      [placeholder]="placeholder | translate"
      [options]="options"
      [id]="id"
      [dataKey]="dataKey"
      [optionValue]="optionValue"
      [optionLabel]="optionLabel"
      [filter]="filter"
      [loading]="loading"
      [disabled]="disabled"
      [class.disabled]="disabled"
      [emptyMessage]="emptyMessage"
      [emptyFilterMessage]="emptyFilterMessage"
      [scrollHeight]="screenHight > 900 ? scrollHeight : '150px'"
      [class.is-valid]="!control?.invalid && control?.touched"
      [class.is-invalid]="control?.invalid && control?.touched"
      [virtualScroll]="virtualScroll"
      [virtualScrollItemSize]="virtualScrollItemSize"
      [appendTo]="appendTo"
      (onChange)="onChangeEvent.emit($event)">
      <ng-template pTemplate="selectedItem" let-selectedOption>
        <div class="d-flex align-items-center gap-2">
          <img
            *ngIf="imageBaseSrc + selectedOption[imageKey] + imageExtension as optionImageSrc"
            [src]="optionImageSrc"
            width="22px"
            height="15px"
            style="border-radius: 3px" />
          @if (translatePrefix) {
            <div>{{ translatePrefix + '.' + selectedOption[optionLabel] | translate }}</div>
          } @else {
            <div>{{ selectedOption[optionLabel] }}</div>
          }
        </div>
      </ng-template>
      <ng-template let-option pTemplate="item">
        <span class="d-flex align-items-center gap-1 px-4 dk-option-label">
          <img
            *ngIf="imageBaseSrc + option[imageKey] + imageExtension as optionImageSrc"
            [src]="optionImageSrc"
            width="22px"
            height="15px"
            style="border-radius: 3px" />
          @if (translatePrefix) {
            <div>{{ translatePrefix + '.' + option[optionLabel] | translate }}</div>
          } @else {
            <div>{{ option[optionLabel] }}</div>
          }
        </span>
      </ng-template>
    </p-select>
    <dk-field-validation-error-message [control]="control" />
  </form>
} @else {
  <div [class.mb-3]="has_mb3" [class.my-3]="has_my3">
    <dk-label [label]="label" [isRequired]="required" [disabled]="disabled" />
    <p-select
      [class.disabled]="disabled"
      #drop
      [(ngModel)]="ngModelValue"
      [placeholder]="placeholder | translate"
      [options]="options"
      [id]="id"
      [dataKey]="dataKey"
      [optionValue]="optionValue"
      [optionLabel]="optionLabel"
      [filter]="filter"
      [loading]="loading"
      [disabled]="disabled"
      [class.disabled]="disabled"
      [virtualScroll]="virtualScroll"
      [virtualScrollItemSize]="virtualScrollItemSize"
      [appendTo]="appendTo"
      [emptyMessage]="emptyMessage"
      [emptyFilterMessage]="emptyFilterMessage"
      [scrollHeight]="screenHight > 900 ? scrollHeight : '150px'"
      (onChange)="onChangeEvent.emit($event)">
      <ng-template pTemplate="selectedItem" let-selectedOption>
        <div class="d-flex align-items-center gap-2">
          <img
            *ngIf="imageBaseSrc + selectedOption[imageKey] + imageExtension as optionImageSrc"
            [src]="optionImageSrc"
            width="22px"
            height="15px"
            style="border-radius: 3px" />
          @if (translatePrefix) {
            <div>{{ translatePrefix + '.' + selectedOption[optionLabel] | translate }}</div>
          } @else {
            <div>{{ selectedOption[optionLabel] }}</div>
          }
        </div>
      </ng-template>
      <ng-template let-option pTemplate="item">
        <div class="d-flex align-items-center gap-1 px-4 dk-option-label">
          <img
            *ngIf="imageBaseSrc + option[imageKey] + imageExtension as optionImageSrc"
            [src]="optionImageSrc"
            width="22px"
            height="15px"
            style="border-radius: 3px" />
          @if (translatePrefix) {
            <div>{{ translatePrefix + '.' + option[optionLabel] | translate }}</div>
          } @else {
            <div>{{ option[optionLabel] }}</div>
          }
        </div>
      </ng-template>
    </p-select>
  </div>
}
